import {IEvaluatorOptions} from "./i-evaluator-options";
import {IndexLiteral, LAZY_CALL_FLAG, LazyCall, Literal, LiteralFlagKind} from "../literal/literal";
import {isBindCallApply} from "../util/function/is-bind-call-apply";
import {TS} from "../../type/ts";

/**
 * Evaluates, or attempts to evaluate, a PropertyAccessExpression
 */
export function evaluatePropertyAccessExpression({node, environment, evaluate, typescript, statementTraversalStack}: IEvaluatorOptions<TS.PropertyAccessExpression>): Literal {
	const expressionResult = evaluate.expression(node.expression, environment, statementTraversalStack) as IndexLiteral;

	const match =
		node.questionDotToken != null && expressionResult == null
			? // If optional chaining are being used and the expressionResult is undefined or null, assign undefined to 'match'
			  undefined
			: expressionResult[node.name.text];

	// If it is a function, wrap it in a lazy call to preserve implicit 'this' bindings. This is to avoid losing the 'this' binding or having to
	// explicitly bind a 'this' value
	if (typeof match === "function" && statementTraversalStack.includes(typescript.SyntaxKind.CallExpression)) {
		return {
			[LAZY_CALL_FLAG]: LiteralFlagKind.CALL,
			invoke: (overriddenThis: Record<string, unknown> | CallableFunction | undefined, ...args: Literal[]) =>
				overriddenThis != null && !isBindCallApply(match, environment)
					? // eslint-disable-next-line @typescript-eslint/ban-types
					  (expressionResult[node.name.text] as Function).call(overriddenThis, ...args)
					: (expressionResult[node.name.text] as CallableFunction)(...args)
		} as LazyCall;
	} else return match;
}
